import postCustomerPreferences from '@/api/customer-data/post-customer-preferences';
import { setCustomerPreferences } from '@/store/actions';
import { useStore } from '@/store/useStore';
import { FunctionComponent, useEffect } from 'react';
import logo from '../../../assets/SWJ/swj-logo.png';
import './styles/default.scss';
import { trackGameScreenMinMax } from '../helpers/swjTracking';

export const MinMaxGameToggle: FunctionComponent = () => {
  const {
    gameExpansionToggleDisplayState: isShowing,
    gameWindowExpansionState: isOn,
    gameWindowExpansionInitialized: isInitialized,
    gameWindowExpansionStateDisabled: disabled,
    setGameWindowExpansionState,
    jackpotOptInStatus: optedIn,
  } = useStore((state) => state.swj);
  const preferences = useStore((state) => state?.customerPreferences);
  const forceDYBPopup = preferences?.showDYBPopup;
  const customerData = useStore((state) => state?.customerData);
  const { spinInProgress: isSpinInProgress } = useStore(
    (state) => state?.gameWindowContext,
  );
  const optedInOption = Number(optedIn) > 0 ? 'in' : 'out'; //unchanged from launcher

  useEffect(() => {
    if (
      !customerData?.loading &&
      preferences &&
      !('showSWJElements' in preferences)
    ) {
      setCustomerPreferences({ ...preferences, showSWJElements: true });
      postCustomerPreferences({ showSWJElements: true });
    }

    // initialise the gw expansion state only once - when not already initialised
    if (preferences && !isInitialized) {
      setGameWindowExpansionState(preferences.showSWJElements);
    }
  }, [customerData, isInitialized]);

  const handleClick = (e) => {
    if (forceDYBPopup) {
      e?.preventDefault?.();
      return;
    }
    if (!disabled && !isSpinInProgress) {
      postCustomerPreferences({ showSWJElements: !isOn });
      setGameWindowExpansionState(!isOn);
      trackGameScreenMinMax(optedInOption, isOn);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (forceDYBPopup) {
      e?.preventDefault?.();
      return;
    }
    if (
      !disabled &&
      !isSpinInProgress &&
      (e.key === 'Enter' || e.key === ' ')
    ) {
      handleClick(e);
    }
  };

  return (
    <div
      className={`min-max-toggle
        ${isOn ? 'on' : 'off'}
        ${(forceDYBPopup ? true : disabled || isSpinInProgress) ? 'disabled' : ''}
        ${isShowing || (!isOn && !isShowing) ? 'show' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={!!isOn}
      aria-disabled={disabled || isSpinInProgress}
    >
      <div className="icon-container">
        <div className="not-show-icon" />
        <div className="icon off-icon" data-testid="swj-minimise-button">
          <div className="cancel-icon" />
          <img className="logo-icon" src={logo} />
        </div>
        <div className="icon on-icon" data-testid="swj-maximise-button">
          <img className="logo-icon" src={logo} />
        </div>
        <div className="white-underlay" />
      </div>
      <div className="text-container">
        <div className="text-on">Hide</div>
        <div className="text-off">Show</div>
      </div>
    </div>
  );
};
